<template>
  <el-card
    class="settings"
    shadow="never">
    <div
      slot="header"
      class="settings-header">
      轮播图  <el-button
        type="danger"
        style="margin-left: 8px;"
        @click="deleteitem">删除</el-button>
    </div>
    <el-form
      ref="form"
      :model="slide"
      label-position="top"
      label-width="100px">
      <el-form-item
        label="轮播样式："
        prop="layoutType">
        <el-radio-group v-model="slide.styleType">
          <el-radio-button :label="1">底部显示圆点</el-radio-button>
          <el-radio-button :label="2">左右切换</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="内容配置："
        prop="graphics">
        <el-button
          type="primary"
          style="margin-bottom: 8px;"
          @click="addMessages">添加</el-button>
        <el-table
          border
          :data="slide.graphics">
          <el-table-column
            label="首图"
            min-width="120"
            :resizable="false"
            prop="">
            <template slot-scope="{$index}">
              <upload-with-crop
                v-model="slide.graphics[$index].image"
                :showTip="false"
                :limit="1"
                :isLt2M="512"
                :autoCropWidth="60"
                :autoCropHeight="60" />
            </template>
          </el-table-column>
          <el-table-column
            :resizable="false"
            min-width="100"
            label="链接类型"
            prop="link">
            <template slot-scope="{row}">{{ row.linkType | linkTypeName(row.contentType) }}</template>
          </el-table-column>
          <el-table-column
            :resizable="false"
            min-width="260"
            label="链接内容"
            prop="title">
          </el-table-column>
          <el-table-column
            :resizable="false"
            label="操作"
            width="70"
            prop="viewUserCount">
            <template slot-scope="{row, $index}">
              <el-dropdown>
                <el-button
                  type="text">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu
                  slot="dropdown">
                  <el-dropdown-item
                    @click.native="selectitem(row, $index)">选择链接</el-dropdown-item>
                  <el-dropdown-item
                    @click.native="deleterowitem($index)">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-alert
        title="只能上传image/*文件，且不超过500kb，建议上传相同宽高比（5 : 3）的图片文件。"
        :closable="false"
        type="warning">
      </el-alert>
    </el-form>
    <content-select-modal
      ref="select"
      @handleSelect="handleSelect" />
  </el-card>
</template>
<script>
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
import ContentSelectModal from '../content-select-modal.vue'
export default {
  name: 'WeCircular',
  components: { UploadWithCrop, ContentSelectModal }, // draggable, ContentCard
  props: {
    value: {
      type: Object,
      default() {
        return { componentName: 'pictureadv', layoutType: 0, styleType: 1, graphics: [], visible: false }
      }
    },
    index: Number
  },
  data() {
    return {
      visible: false,
      dragOptions: { animation: 0, disabled: false, group: 'description', ghostClass: 'ghost' }
    }
  },
  computed: {
    slide: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    deleteitem() {
      this.$emit('deleteItem', this.index)
    },
    deleterowitem(index) {
      this.slide.graphics.splice(index, 1)
    },
    selectitem(row, $index) {
      this.$refs.select.init(row, $index)
    },
    handleSelect(info, index) {
      this.$set(this.slide.graphics, index, { ...this.slide.graphics[index], ...info })
    },
    addMessages() {
      this.slide.graphics.push({ title: '', image: [], linkType: null, link: null })// 等同id
    },
    submit() {
      return new Promise((resolve, reject) => {
        const graphics = this.slide.graphics
        if (graphics.length === 0 || graphics.some(i => i.image.length === 0 || !i.title)) {
          this.$message.error('请填写完整的信息')
          reject(new Error(JSON.stringify({ index: this.index })))
        } else {
          resolve()
        }
      })
    }
  }
}
</script>
